module.exports = __webpack_public_path__ + "static/media/logo.a1c1482a.png";